import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Bot, ArrowRight } from 'lucide-react'

export default function Landing() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <nav className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Bot className="w-8 h-8 text-gray-900 mr-2" />
              <span className="text-xl font-semibold text-gray-900">EXPLAT Agent</span>
            </div>
            <button
              onClick={() => navigate('/auth/login')}
              className="btn-primary"
            >
              로그인
            </button>
          </div>
        </div>
      </nav>

      <section className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-100 text-primary-600 mb-6">
            <Bot className="w-8 h-8" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            EXPLAT Agent
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            에이전트 서비스를 위해 로그인해 주세요.
          </p>
          <button
            onClick={() => navigate('/auth/login')}
            className="btn-primary inline-flex items-center"
          >
            로그인
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      </section>
    </div>
  )
}
